import MuiTextField, { TextFieldProps } from '@mui/material/TextField';

export const TextField = ({ children, ...props }: TextFieldProps) => (
  <MuiTextField {...props}>{children}</MuiTextField>
);

export type { TextFieldProps };
